// extracted by mini-css-extract-plugin
export var infoItem = "_pp-2";
export var title = "_pp-0";
export var value = "_pp-1";